import { createRouter, createWebHistory } from 'vue-router'

import { routes as homeRoutes } from '@/help-seeker/app/home/routes.ts'
import { routes as mailRoutes } from '@/help-seeker/app/mail/routes.ts'
import { env } from '@/utilities/env.ts'

const router = createRouter({
	history: createWebHistory(env.BASE_URL),
	routes: [...homeRoutes, ...mailRoutes],
	scrollBehavior(to, from, savedPosition) {
		return savedPosition ?? { top: 0 }
	},
})

export default router
